import { mentorsRepository } from '@/repositories'
import { MentorsModel } from '@models'

function useListMentors({
	page,
	search,
	vertical,
	availabilities,
	tag,
}: {
	page: string
	search?: string
	vertical?: string
	availabilities?: string
	tag?: string
}) {
	const { data, isLoading, isSuccess } = mentorsRepository.useListQuery({
		page,
		search,
		vertical,
		availabilities,
		tag,
	})

	return { data, isLoading, isSuccess }
}

function useGetMentor({ mentorSlug }: { mentorSlug: string }) {
	const { data, isLoading, isError } = mentorsRepository.useGetQuery({
		mentorSlug,
	})

	return { data, isLoading, isError }
}

function useGetAvailabilitiesMentor() {
	const { data, isLoading, isError, isSuccess } =
		mentorsRepository.useGetAvailabilitiesQuery()

	return { data, isLoading, isError, isSuccess }
}

function useUpdateAvailabilitiesMentorMutation() {
	const [_updateAvailabilities, { isLoading, isSuccess, data }] =
		mentorsRepository.useUpdateAvailabilitiesMutation()

	async function execute(body: MentorsModel.Availabilities) {
		try {
			await _updateAvailabilities({ ...body })
		} catch (error) {
			console.error(error)
		}
	}

	return { execute, data, isLoading, isSuccess }
}

function useGetMutation() {
	const [_getMentor, { isLoading, isSuccess, data }] =
		mentorsRepository.useGetMutationMutation()

	async function execute({ mentorSlug }: { mentorSlug: string }) {
		try {
			await _getMentor({ mentorSlug })
		} catch (error) {
			console.error(error)
		}
	}

	return { execute, data, isLoading, isSuccess }
}

function useGetRescheduleMutation() {
	const [_getAviabilitiesMentor, { isLoading, isSuccess, data }] =
		mentorsRepository.useGetRescheduleMutation()

	async function execute({
		mentorSlug,
		mentorshipId,
	}: {
		mentorSlug: string
		mentorshipId: string
	}) {
		try {
			await _getAviabilitiesMentor({ mentorSlug, mentorshipId })
		} catch (error) {
			console.error(error)
		}
	}

	return { execute, data, isLoading, isSuccess }
}

function useListPaymentsMentor() {
	const { data, isLoading } = mentorsRepository.useListPaymentsQuery()

	return { data, isLoading }
}

function useUpdateBankMutation() {
	const [_updatePix, { isLoading, isSuccess, data }] =
		mentorsRepository.useUpdateBankAccountMutation()

	async function execute(body: { pixKey: string; pixKeyType: string }) {
		try {
			await _updatePix({ ...body })
		} catch (error) {
			console.error(error)
		}
	}

	return { execute, data, isLoading, isSuccess }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default {
	list: useListMentors,
	getMentor: useGetMentor,
	getMutation: useGetMutation,
	getAviabilities: useGetRescheduleMutation,
	getAvailabilitiesMentor: useGetAvailabilitiesMentor,
	listPayments: useListPaymentsMentor,
	updatePix: useUpdateBankMutation,
	updateAvailabilities: useUpdateAvailabilitiesMentorMutation,
}
